export const cacheControl =
  (directives) =>
  ({ res }) => {
    if (!process.server) {
      return;
    }
    res.setHeader('Cache-Control', directives);
  };

export const cacheControlNoStore = cacheControl('no-store,must-revalidate,max-age=0');
